/**
 * Catálogo de productos de demostración para recetas (sin API).
 * Sustituir por GET /products cuando se conecte el backend.
 */
export const MOCK_PRODUCTOS_CATALOGO = [
  { id: 1, code: 'PRD-001', name: 'Harina de trigo' },
  { id: 2, code: 'PRD-002', name: 'Harina integral' },
  { id: 3, code: 'PRD-003', name: 'Azúcar refinada' },
  { id: 4, code: 'PRD-004', name: 'Azúcar glass' },
  { id: 5, code: 'PRD-005', name: 'Manteca vegetal' },
  { id: 6, code: 'PRD-006', name: 'Mantequilla sin sal' },
  { id: 7, code: 'PRD-007', name: 'Levadura instantánea' },
  { id: 8, code: 'PRD-008', name: 'Huevo' },
  { id: 9, code: 'PRD-009', name: 'Leche entera' },
  { id: 10, code: 'PRD-010', name: 'Leche evaporada' },
  { id: 11, code: 'PRD-011', name: 'Leche condensada' },
  { id: 12, code: 'PRD-012', name: 'Crema para batir' },
  { id: 13, code: 'PRD-013', name: 'Queso crema' },
  { id: 14, code: 'PRD-014', name: 'Café espresso' },
  { id: 15, code: 'PRD-015', name: 'Cajeta' },
  { id: 16, code: 'PRD-016', name: 'Agua' },
  { id: 17, code: 'PRD-017', name: 'Sal' },
  { id: 18, code: 'PRD-018', name: 'Frutos rojos congelados' },
  { id: 19, code: 'PRD-019', name: 'Galleta molida' },
  { id: 20, code: 'PRD-020', name: 'Crema de limón' },
  { id: 21, code: 'PRD-021', name: 'Merengue' },
  { id: 22, code: 'PRD-022', name: 'Base galleta' },
  { id: 23, code: 'PRD-023', name: 'Espuma de leche' },
  { id: 24, code: 'PRD-024', name: 'Chocolate semiamargo' },
  { id: 25, code: 'PRD-025', name: 'Vainilla líquida' },
  { id: 26, code: 'PRD-026', name: 'Canela en polvo' },
  { id: 27, code: 'PRD-027', name: 'Aceite vegetal' },
  { id: 28, code: 'PRD-028', name: 'Polvo para hornear' },
  { id: 29, code: 'PRD-029', name: 'Colorante vegetal' },
  { id: 30, code: 'PRD-030', name: 'Almendra molida' },
];

export function getMockProductosCatalogo() {
  return MOCK_PRODUCTOS_CATALOGO;
}

export function filterProductosMock(query, limit = 50) {
  const q = String(query || '')
    .trim()
    .toLowerCase();
  if (!q) return MOCK_PRODUCTOS_CATALOGO.slice(0, limit);
  return MOCK_PRODUCTOS_CATALOGO.filter(
    (p) =>
      p.name.toLowerCase().includes(q) ||
      p.code.toLowerCase().includes(q)
  ).slice(0, limit);
}
